import React, { useContext, useMemo } from 'react';
import { PatientChartContext } from '../../../contexts/patientChart';
import { RESPONSE_POPUP_KEY, MODAL_KEY, CONFIRMATION_POPUP_KEY, MESSAGE } from '../../../constants/patientChart.constant';
import { POPUP_TYPE } from '../../subComponents/popup';
import { removeXSSAttacks } from '../../../common/helper';
import PPButton from '../../subComponents/button';
import Select from '../../subComponents/select';

export const TextPatient = ({
  orderId = '',
  patientId = '',
  messageTemplates: templates = {},
  sendTextInfo = {},
  sendText = async () => {},
}) => {
  const { loading } = sendTextInfo.api;
  const { message, setMessage, handleModalOpen, handleMultipleModalClose } = useContext(PatientChartContext);

  const messageCollection = useMemo(() => {
    const collection = new Map();
    for (let i = 0; i < templates.data.length; i++) {
      const template = templates.data[i] || { display: '' };
      collection.set(template.value, template);
    }
    return collection;
  }, [templates.data]);

  const handleChange = ({ target }) => {
    const template = messageCollection.get(target.value) || { display: '' };
    setMessage({ value: target.value, template });
  };

  const handleSendText = async ({ key }) => {
    const body = {
      OrderId: orderId,
      PatientId: patientId,
      TemplateId: message.value,
    };

    try {
      const { status, data } = await sendText(body);
      if (status === 200) {
        setMessage(MESSAGE());
        handleMultipleModalClose.call(this, { keys: [key, MODAL_KEY.TEXT_PATIENT] });
      }

      if (status !== 200) {
        const { Error: error = 'Failed to send text to patient. Please try later.' } = data;
        const heading = 'Error';

        handleModalOpen({
          key:
          RESPONSE_POPUP_KEY.TEXT_PATIENT, modal: {
            heading,
            type: POPUP_TYPE.ERROR,
            message: error,
          }
        });
      }
    } catch (e) {

    }
  };

  const Template = (
    <div className='flex flex-column flex-fill m-b-5'>
      <div className='flex align-items-center m-b-5'>
        <label className="input-label min-width-100 m-r-4">Text Template:</label>
        <Select
          id='templateId'
          labelId="templateId"
          value={message.value}
          onChange={handleChange}
          items={templates.data}
        />
      </div>

      <div className='flex flex-fill align-items-center'>
        <label className="input-label min-width-100 m-r-4">Message:</label>
        <div
          className='flex flex-fill border-light-grey-1 min-height-160 height-full p-4 font-proxima-nova font-14 color-dark-grey'
          dangerouslySetInnerHTML={{
            __html: removeXSSAttacks(message.template.display),
          }}
        />
      </div>
    </div>
  );

  const Actions = (
    <div className='flex justify-content-flex-end'>
      <PPButton label='Text Patient' variant='contained' loading={loading} disabled={!message.template.display} endGutter onClick={handleSendText.bind(this, { key: CONFIRMATION_POPUP_KEY.TEXT_PATIENT, modal: {} })} />
      <PPButton label='Cancel' variant='cancel' disabled={loading} onClick={handleMultipleModalClose.bind(this, { keys: [CONFIRMATION_POPUP_KEY.TEXT_PATIENT, MODAL_KEY.TEXT_PATIENT] })} />
    </div>
  );

  return (
    <div className='flex flex-column flex-fill m-5 patient-chart-container'>
      {Template}
      {Actions}
    </div>
  );
};

export default TextPatient;
